import { loadRequestExportZipFieldsList } from '../../../api'
import { TableExportModal } from '../../Table'

import { FormFields } from './FormFields'
import {
  checkTask,
  startExport,
} from './RequestExportEmailsFilesChatsModal.api'
import {
  INITIAL_VALUES,
  QA_NAME_MODAL_EXPORT_EMAIL_FILES_CHATS,
} from './RequestExportEmailsFilesChatsModal.constants'
import { getSelectedZipFieldIds } from './RequestExportEmailsFilesChatsModal.utils'

function RequestExportEmailsFilesChatsModal({
  loadFieldList = loadRequestExportZipFieldsList,
  tableExportGetResponseLinkModalProps,
  ...restProps
}) {
  return (
    <TableExportModal
      {...restProps}
      Fields={FormFields}
      checkTask={checkTask}
      formModalProps={{
        formTitle: 'Request.ModalExportZipTitleKey',
        submitButtonText: 'Modal.ExportDataBtnKey',
      }}
      getSelectedFieldIds={getSelectedZipFieldIds}
      initialValues={INITIAL_VALUES}
      loadFieldList={loadFieldList}
      qaName={QA_NAME_MODAL_EXPORT_EMAIL_FILES_CHATS}
      startExport={startExport}
      tableExportGetResponseLinkModalProps={{
        ...tableExportGetResponseLinkModalProps,
        errorTextKey: 'Modal.ExportRequestsDataErrorMessageKey',
        errorTitleKey: 'Modal.ExportRequestsDataErrorTitleKey',
        fieldTitleKey: 'Table.ExportEmailsFilesChatsAttentionTextKey',
      }}
    />
  )
}

export default RequestExportEmailsFilesChatsModal
